export const REQUEST_GET_BORROWERS = 'REQUEST_GET_BORROWERS';
export const RECEIVE_GET_BORROWERS = 'RECEIVE_GET_BORROWERS';
export const RECEIVE_GET_BORROWERS_ERROR = 'RECEIVE_GET_BORROWERS_ERROR';
